<template>
    <section class="invoice-preview-wrapper">
        <b-alert variant="danger" :show="!sectionData && !loading">
            <h4 class="alert-heading">Erreur lors de la récupération des données de la section</h4>
            <div class="alert-body">
                Aucune section trouvée avec cet identifiant. Consultez
                <b-link class="alert-link" :to="{ name: 'section' }">la liste des sections</b-link>
                pour d’autres sections.
            </div>
        </b-alert>
        <b-row v-if="sectionData" class="invoice-preview">
            <b-col cols="12">
                <b-card no-body class="invoice-preview-card">
                    <b-card-body class="invoice-padding pb-0">
                        <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                            <div>
                                <div class="logo-wrapper">
                                    <b-link class="alert-link" :to="{ name: 'section' }">
                                        <h4 class="text-primary invoice-logo">Section</h4>
                                    </b-link>
                                </div>
                                <b-card-text class="mb-25">
                                    <span class="invoice-number">{{ sectionData.title }}</span>
                                </b-card-text>
                                <b-card-text class="mb-25">
                                    <span class="invoice-number">{{ sectionData.description }}</span>
                                </b-card-text>
                            </div>
                            <div class="mt-md-0 mt-2">
                                <h4 class="invoice-title">
                                    Position
                                    <span class="invoice-number">#{{ sectionData.position }}</span>
                                </h4>
                                <div class="demo-inline-spacing">
                                    <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="primary"
                                        @click="openAddModal">
                                        <feather-icon icon="EditIcon" class="mr-50" />
                                        <span class="align-middle">Questionnaire</span>
                                    </b-button>
                                    <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="gradient-danger">
                                        <feather-icon icon="InfoIcon" class="mr-50" />
                                        <span class="align-middle">Info</span>
                                    </b-button>
                                </div>

                            </div>

                        </div>
                    </b-card-body>

                </b-card>

            </b-col>

            <b-col cols="12" v-if="sectionData.position === 1">
                <user-objective-view v-if="userData" :userData="userData" />
            </b-col>


            <b-col cols="12" v-else-if="isStandard">

                    <b-card no-body>
                        <b-card-body>
                            <div v-for="component in componentsModalList" :key="component.titre">
                                <b-card-actions ref="cardActions" :title="component.titre" action-collapse action-close>
                                    <b-row>
                                        <b-col :cols="component.taille" :xl="component.taille">
                                            <b-form-group :label="component.titre">
                                                <!-- For non-list components -->
                                                <b-card v-if="component.label === 'Tags'">
                                                    <b-form-tags v-model="value" no-outer-focus>
                                                        <template
                                                            v-slot:default="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
                                                            <b-input-group aria-controls="my-custom-tags-list">
                                                                <input v-bind="inputAttrs"
                                                                    placeholder="Nouvelle balise - Appuyez sur Entrée pour ajouter"
                                                                    class="form-control" v-on="inputHandlers">
                                                                <b-input-group-append>
                                                                    <b-button variant="primary" @click="addTag()">
                                                                        Ajouter
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                            <ul id="my-custom-tags-list"
                                                                class="list-unstyled d-inline-flex flex-wrap mb-0"
                                                                aria-live="polite" aria-atomic="false"
                                                                aria-relevant="additions removals">

                                                                <b-card v-for="tag in tags"
                                                                    :id="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
                                                                    :key="tag" tag="li"
                                                                    class="shadow-none border mt-1 mr-1 mb-0"
                                                                    body-class="py-1 pr-2 text-nowrap">
                                                                    <strong>{{ tag }}</strong>
                                                                    <b-button variant="link" size="sm"
                                                                        :aria-controls="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
                                                                        class="py-0" @click="removeTag(tag)">
                                                                        Supprimer
                                                                    </b-button>
                                                                </b-card>
                                                            </ul>
                                                        </template>
                                                    </b-form-tags>
                                                </b-card>
                                                <component v-else-if="component.type !== 'liste'"
                                                    :is="resolveComponent(component.value)" :title="component.titre"
                                                    :description="component.description"
                                                    v-b-tooltip.hover.v-primary="component.description" v-bind="{
                                                        switch: component.autre === 'switch',
                                                        inline: component.autre === 'inline'
                                                    }" :required="component.required && component.type !== 'liste'" />
                                                <!-- For list components -->
                                                <component v-else :is="resolveComponent(component.value)"
                                                    :title="component.titre" :description="component.description"
                                                    v-b-tooltip.hover.v-primary="component.description"
                                                    :options="component.valueList" v-bind="{
                                                        multiple: component.autre === 'multiple',
                                                        switch: component.autre === 'switch',
                                                        inline: component.autre === 'inline'
                                                    }" :required="component.required && component.type === 'liste'" />

                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-card-actions>
                            </div>
                        </b-card-body>

                    </b-card>

            </b-col>
            <b-col cols="12" v-else>

                <b-card no-body>
                    <b-card-body>
                        <div v-for="(section, index) in componentSections" :key="index">
                            <b-card-actions ref="cardAction" :title="section.titre" :tooltips="{
                                collapse: 'Réduire ' + section.titre,
                                refresh: 'Modifier les données de ' + section.titre,
                                close: 'Supprimer ' + section.titre,
                                new: (section.active ? 'Désactiver ' : 'Activer ') + section.titre
                            }" @collapse="handleCollapse(section)" @refresh=" handleUpdate(section)"
                                :actionCollapse="true" :actionRefresh="true" :actionClose="!section.isUsed"
                                :actionNewAction="section.isUsed" @close="!section.isUsed ? handleClose(section) : null"
                                @new="section.isUsed ? handleCustomAction(section) : null">
                                <div v-for="componentsTable in section.tableList" :key="componentsTable.position">

                                    <b-card-header class="pb-30">
                                        <b-card-title>{{ componentsTable.titre }}</b-card-title>
                                    </b-card-header>

                                    <b-row>
                                        <b-col v-for="component in section.modalList" :key="component.titre"
                                            :cols="component.taille" :xl="component.taille">

                                            <b-form-group :label="component.titre">


                                                <component
                                                    v-if="component.type !== 'liste' && component.value !== 'b-form-tags'"
                                                    :is="resolveComponent(component.value)" :title="component.titre"
                                                    :description="component.description"
                                                    v-b-tooltip.hover.v-primary="component.description"
                                                    v-bind="{ switch: component.autre === 'switch', inline: component.autre === 'inline', readonly: component.readonly === 'readonly' }"
                                                    :required="component.required && component.type !== 'liste'" />
                                                <!-- <b-card  v-if="component.label === 'Tags'"> component.type !== 'liste' &&-->
                                                <!-- <b-form-group> -->
                                               <b-form-tags   v-else-if=" component.value === 'b-form-tags'"
                                                    label="Vous pouvez entrer au maximum 200 caractères." v-model="value" no-outer-focus
                                                        input-id="tags-state-event" :tag-validator="validator" >
                                                        <template
                                                            v-slot:default="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
                                                            <b-input-group aria-controls="my-custom-tags-list">
                                                                <input v-bind="inputAttrs"
                                                                    placeholder="Nouvelle balise - Appuyez sur Entrée pour ajouter"
                                                                    class="form-control" v-on="inputHandlers">
                                                                <b-input-group-append>
                                                                    <b-button variant="primary" @click="addTag()">
                                                                        Ajouter
                                                                    </b-button>
                                                                </b-input-group-append>

                                                            </b-input-group>
                                                            <!-- <b-form-valid-feedback v-if="!showLengthWarning" >

                                                            </b-form-valid-feedback> -->
                                                            <p v-if="!showLengthWarning" class="text-danger mt-2">
                                                                Vous pouvez entrer au maximum 200 caractères. </p>
                                                            <ul id="my-custom-tags-list"
                                                                class="list-unstyled d-inline-flex flex-wrap mb-0"
                                                                aria-live="polite" aria-atomic="false"
                                                                aria-relevant="additions removals">

                                                                <b-card v-for="tag in tags"
                                                                    :id="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
                                                                    :key="tag" tag="li"
                                                                    class="shadow-none border mt-1 mr-1 mb-0"
                                                                    body-class="py-1 pr-2 text-nowrap">
                                                                    <strong>{{ tag }}</strong>
                                                                    <b-button variant="link" size="sm"
                                                                        :aria-controls="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
                                                                        class="py-0" @click="removeTag(tag)">
                                                                        Supprimer
                                                                    </b-button>
                                                                </b-card>
                                                            </ul>
                                                        </template>
                                                    </b-form-tags>

                                                <!-- </b-form-group> -->
                                                <!-- </b-card > -->

                                                <component v-else :is="resolveComponent(component.value)"
                                                    :title="component.titre" :description="component.description"
                                                    v-b-tooltip.hover.v-primary="component.description"
                                                    :options="component.valueList"
                                                    v-bind="{ multiple: component.autre === 'multiple', switch: component.autre === 'switch', inline: component.autre === 'inline', readonly: component.readonly === 'readonly' }"
                                                    :required="component.required && component.type === 'liste'" />
                                            </b-form-group>

                                        </b-col>

                                    </b-row>
                                    <hr>
                                </div>

                            </b-card-actions>

                        </div>
                    </b-card-body>

                </b-card>

            </b-col>



        </b-row>
        <b-modal v-model="isModalActive" :title="modalTitle" @hide="resetModal" id="modal-lg" :ok-title="okTitle"
            cancelTitle="Fermer" centered size="lg" @ok="handleSubmit">
            <b-form v-if="isStandard">
                <standard-dynamic-form :currentContentSection="currentContentSection"
                    :champsEnumOptions="champsEnumOptions" :sections="sections"
                    @update:currentContentSection="handleContentSectionUpdate">
                </standard-dynamic-form>
            </b-form>



            <b-form v-else>
                <dynamic-form :componentModelSection="componentModelSection" :champsEnumOptions="champsEnumOptions"
                    :sections="sections" @update:componentModelSection="handleComponentModelSectionUpdate">

                </dynamic-form>

            </b-form>
        </b-modal>
    </section>
</template>
<script>
import { BAlert, BRow, BCol, BCard, BCardBody, BLink, BCardText, BButton, BModal, BForm,BFormInvalidFeedback ,VBPopover,VBTooltip} from 'bootstrap-vue';
import BCardActions from '@core/components/b-card-actions/BCardActions.vue';
import { getSommeContentById } from '@/services/SommeContentService';
import { getIdSection, allSection } from '@/services/SectionService';
import { allSectionContent, updateSectionContent, saveSectionContent } from '@/services/ContentSectionService';
import { allSectionComponentModelSections, saveComponentModelSection, getComponentModelSectionById,deleteComponentModelSection } from '@/services/ComponentModelSectionService';
import { allChampsModel } from '@/services/ChampService';
import StandardDynamicForm from './StandardDynamicForm.vue';
import DynamicForm from './DynamicForm.vue';
import Ripple from 'vue-ripple-directive';
import UserObjectiveView from '@/views/objectif/UserObjectiveView.vue';
import NumericInput from '@/util/NumericInput.vue'

export default {
    components: {
        BAlert,
        BRow,
        BCol,
        BCard,
        BCardBody,
        BLink,
        BCardText,
        BButton,
        BForm,
        BCardActions,
        StandardDynamicForm,
        DynamicForm,
        UserObjectiveView,
        VBPopover,
        VBTooltip,
      NumericInput
        // BFormInvalidFeedback
    },
    directives: {
        'b-tooltip': VBTooltip,
        Ripple
    },
    data() {
        return {
            userData:{},
            componentsModalList: [],
            tags: [],
            sectionData: null,
            loading: true,
            isModalActive: false,
            modalTitle: '',
            currentContentSection: {
              idPublic: null,
              titre: '',
              description: '',
              required: false,
              taille: 0,
              champsModel: { label: '' },
              valueList: [],
              somme: false,
              max: 0,
              readonly: null,
              section: { id: null },
              response: 0,
            },
            sections: [],
            champsEnumOptions: [],
            componentModelSection: {
              idPublic: null,
                titre: '',
                objectif: false,
                contentSections: [{
                  idPublic: null,
                  titre: '',
                  description: '',
                  required: false,
                  taille: 0,
                  max: 0,
                  champsModel: {},
                  somme: false,
                  valueList: [],
                  contentSection: {},
                  componentModel: [],
                  response: 0,
                }],
                componentModels: [{
                  idPublic: null,
                  titre: '',
                  description: '',
                  taille: 0,
                  somme: false,
                }],
                section: { idPublic: null }
            },
            componentSections: [],
            result: null,
            currentTag: "", // Stocke le tag en cours
            showLengthWarning: true, // Affiche le message d'avertissement
            value: []

        }

    },
    computed: {
        okTitle() {
            return this.isEditMode ? 'Modifier' : 'Créer';
        },
        isStandard() {
            return this.sectionData && this.sectionData.responseChoice === 'Standard';
        },
    },
    methods: {

        validator(tag) {
            this.showLengthWarning = tag.length > 0 && tag.length < 200;
            return this.showLengthWarning;
        },
        isStandardSection() {
            const selectedSection = this.sections.find(section => section.idPublic === this.selectedSectionId);
            return selectedSection && selectedSection.type === 'standard';
        },
        handleCollapse(section) {
            section.collapsed = !section.collapsed; // Exemple: modification de l'état local
        },
        async handleUpdate(section) {
            this.resetModal();
            this.isEditMode = true;

            if (this.isStandard) {
                this.currentContentSection = { ...section }; // Clone l'objet pour éviter les mutations directes
            } else {
                this.nombres = section.modalList.length;

                delete section.tableList;
                delete section.modalList;
                // this.componentModelSection = { ...section };
                // this.listTag = this.componentModelSection.componentModels.map(model => model.titre);

                // for (let content of this.componentModelSection.contentSections) {
                //     if (content.sommeContent && content.sommeContent.id) {
                //         this.result = await getSommeContentById(content.sommeContent.id);
                //         content.componentModel = this.result.componentModel;
                //         content.contentSection = this.result.contentSection;
                //         this.selectedSectionId = content.contentSection.section.id;
                //     }
                // }






            }
            this.modalTitle = (`Modifier le composant : ${section.titre}`);

            this.isModalActive = true;


            // Rafraîchir les données de cette section
        },
        async handleClose(section) {

            await deleteComponentModelSection(section.idPublic)
            this.toast('Supprimer avec succes','Succès','success', true, 'AlertTriangleIcon', 'bottom-right')
            this.componentSections = this.componentSections.filter(s => s.idPublic !== section.idPublic);

            // this.toast('Erreur lors de la soumission', 'Erreur', 'danger', true, 'AlertTriangleIcon', 'bottom-right');

            // Supprimer ou masquer la section
            // this.componentSections = this.componentSections.filter(s => s !== section);
        },
        handleCustomAction(section) {
            // Gérer une nouvelle action spécifique
        },
        toast(message, title, variant, solid, icon, position) {
            this.$bvToast.toast(message, {
                title: title,
                variant: variant,
                solid: solid,
                icon: icon,
                position: position
            });
        },
        async fetchSectionId() {
            try {
                this.sectionData = await getIdSection(this.$route.params.id);
              this.componentModelSectionList = await allSectionComponentModelSections(this.sectionData.idPublic);
                // if (this.isStandard) {
                //     this.contentSection = await allSectionContent(this.sectionData.idPublic);
                //
                // } else {
                //
                // }this.contentSection && this.contentSection.length > 0 ||

                if ( this.componentModelSectionList && this.componentModelSectionList.length > 0) {
                    this.populateComponents();
                }
            } catch (error) {
                console.error(error);
                this.toast('Erreur lors de la récupération des données de la section', 'Erreur', 'danger', true, 'AlertTriangleIcon', 'bottom-right')
            } finally {
                this.loading = false;
            }
        },
        populateComponents() {
            if (this.isStandard) {
                // this.componentsModalList = this.componentModelSectionList.map(section => ({
                //     ...section.componentModels,
                //     value: section.componentModels.champsModel.valeur,
                //     type: this.currentContentSection.champsModel.type
                //
                // }));
              this.componentsModalList = this.componentModelSectionList.flatMap((section) => {
                return section.contentSections.map((contentSection) => ({
                  ...contentSection,
                  value: contentSection.champsModel?.valeur,
                  type: contentSection.champsModel?.type
                }))
              })
            } else {
                this.componentSections = this.componentModelSectionList.map((section) => {


                    return {
                        ...section,
                        tableList: section.componentModels,
                        modalList: section.contentSections.map(contentSection => ({

                            ...contentSection,
                            value: contentSection.champsModel.valeur
                        }))
                    };
                });

            }
        },
        async fetchSectionsAll() {
            try {
                this.sections = await allSection();
            } catch (error) {
                console.error('Erreur lors du chargement des sections :', error);
            }
        },
        async champsData() {
            const champs = await allChampsModel();
            this.champsEnumOptions = champs.map(champ => ({
              idPublic: champ.idPublic,
                label: champ.label,
                value: champ.valeur,
                type: champ.type,
                autre: champ.autre,
                autres: champ.autres || ''
            }));
        },

        openAddModal() {
            this.modalTitle = 'Créer un nouveau composant';
            this.isEditMode = false;
            this.resetModal();
            this.isModalActive = true;
        },
        resetModal() {
            if (this.isStandard) {
                this.currentContentSection = {
                  idPublic: null,
                    titre: '',
                    description: '',
                    required: false,
                    taille: 0,
                    champsModel: { label: '' },
                    valueList: [],
                    max: 0,
                    readonly: false,
                    section: { idPublic: null }
                };
            }else{
                this.componentModelSection= {
                  idPublic: null,
                titre: '',
                objectif: false,
                contentSections: [{
                  idPublic: null,
                    titre: '',
                    description: '',
                    required: false,
                    taille: 0,
                    champsModel: {},
                    somme: false,
                    valueList: [],
                    contentSection: {},
                    componentModel: []
                }],
                componentModels: [{
                  idPublic: null,
                    titre: '',
                    description: '',
                    taille: 0,
                    somme: false,
                }],
                section: { idPublic: null }
            };
            }
        },
        handleComponentModelSectionUpdate(updatedSection) {


            // this.componentModelSection = { ...updatedSection };
        },
        handleContentSectionUpdate(updatedSection) {
            this.currentContentSection = { ...updatedSection };
        },
        async handleSubmit() {
          this.componentModelSection.section.idPublic = this.sectionData.idPublic;

          if (this.isStandard) {
            this.componentModelSection.contentSections = [ this.currentContentSection ]
               // this.currentContentSection.section.idPublic = this.sectionData.idPublic;
                // try {
                //     if (this.isEditMode) {
                //         await updateSectionContent(this.sectionData.idPublic, this.currentContentSection);
                //         this.toast('Composant mis à jour avec succès', 'Succès', 'success', true, 'CheckIcon', 'bottom-right');
                //
                //     } else {
                //
                //         await saveSectionContent(this.currentContentSection);
                //
                //         this.toast('Composant créé avec succès', 'Succès', 'success', true, 'CheckIcon', 'bottom-right');
                //     }
                //     await this.fetchSectionId();
                // } catch (error) {
                //     this.toast('Erreur lors de la soumission', 'Erreur', 'danger', true, 'AlertTriangleIcon', 'bottom-right');
                // }
            } else {
                this.transformContentSections();
            }
          try {

            if (this.isEditMode) {
              this.toast('Composant mis à jour avec succès', 'Succès', 'success', true, 'CheckIcon', 'bottom-right');

            } else {

              await saveComponentModelSection(this.componentModelSection);
              this.toast('Composant créé avec succès', 'Succès', 'success', true, 'CheckIcon', 'bottom-right');

            }
            await this.fetchSectionId();
          } catch (error) {
            console.error(error)
            this.toast('Erreur lors de la soumission', 'Erreur', 'danger', true, 'AlertTriangleIcon', 'bottom-right');

          }
        },
        resolveComponent(componentValue) {
            return componentValue || 'b-form-textarea';
        },

    transformContentSections() {
        // Initialisation des structures pour contentSections
        const sommeContentSections = {
            componentModel: [],
            contentSection: []
        };

        // Traitement des contentSections
        this.componentModelSection.contentSections.forEach((section, index) => {
            if (section.componentModel) {
                sommeContentSections.componentModel.push(section.componentModel);
            }
            if (section.contentSection) {
                sommeContentSections.contentSection.push(section.contentSection);
            }
            delete section.contentSection;
            delete section.componentModel;
        });

        // Mise à jour de contentSections avec sommeContent
        this.componentModelSection.contentSections = this.componentModelSection.contentSections.map((section, index) => {
            return {
                ...section,
                sommeContent: {
                    componentModel: sommeContentSections.componentModel[index] || null,
                    contentSection: sommeContentSections.contentSection[index] || null
                }
            };
        });

        // Initialisation des structures pour componentModels
        const sommeContentModels = {
            componentModel: [],
            contentSection: []
        };

        // Traitement des componentModels
        this.componentModelSection.componentModels.forEach((section, index) => {
            if (section.componentModel) {
                sommeContentModels.componentModel.push(section.componentModel);
            }
            if (section.contentSection) {
                sommeContentModels.contentSection.push(section.contentSection);
            }
            delete section.contentSection;
            delete section.componentModel;
        });

        // Mise à jour de componentModels avec sommeContent
        this.componentModelSection.componentModels = this.componentModelSection.componentModels.map((section, index) => {
            return {
                ...section,
                sommeContent: {
                    componentModel: sommeContentModels.componentModel[index] || null,
                    contentSection: sommeContentModels.contentSection[index] || null
                }
            };
        });
    }

    },
    mounted() {
        this.fetchSectionId();
        this.fetchSectionsAll();
        this.champsData();
    }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>


<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";

.form-item-section {
    background-color: $product-details-bg;
}

.form-item-action-col {
    width: 27px;
}

.repeater-form {
    transition: .35s height;
}

.v-select {

    &.item-selector-title,
    &.payment-selector {
        background-color: #fff;

        .dark-layout & {
            background-color: #283046;
        }
    }
}

.raf-accordion .card-header {
    padding: 1.5rem;
}

.raf-accordion .card-body {
    padding: 0 1.5rem 1.5rem 1.5rem;
}

.dark-layout {
    .form-item-section {
        background-color: $theme-dark-body-bg;

        .row .border {
            background-color: $theme-dark-card-bg;
        }
    }
}
</style>
